import Constant, { WEB_HOST } from "../../utils/constant";
export const APP_DOWNLOAD = () => {
    return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].host}/nh/App-Download.html`;
};
export const IOS_DOWNLOAD = "https://apps.apple.com/us/app/lightinthebox-online-shopping/id438474115";
export const ANDROID_DOWNLOAD = "https://play.google.com/store/apps/details?id=com.lightinthebox.android";
export const CUSTOMER_SERVICE = () => {
    return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/r/contact-us.html`;
};
export const MIDDLE_QUERY = () => {
    return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/index.php?main_page=`;
};
export const SEARCH_RESULT = () => {
    return `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/index.php?main_page=advanced_search_result&inc_subcat=1&search_in_description=0&keyword=`;
};
